import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import LoginHero from "../../../assets/heroes/waiting-bg.png";
import { indexSessionStatus } from "../../../api/endpoints/learner/waiting";
import { useQuery } from "react-query";
import LogoWithLanguage from "../../../components/logo-with-language/LogoWithLanguage";

function SessionWaitingPage() {
  const LocalBasePath = "page.waiting";
  const navigate = useNavigate();
  const { learner_token = "" } = useParams();
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { data: sessionInfo } = useQuery(
    ["fetchWaitingSession", indexSessionStatus, learner_token],
    () => {
      return indexSessionStatus(learner_token);
    },
    {
      refetchInterval: 1 * 60 * 1000, // 1 minutes
      select: (response) => {
        if (response.isSuccess) {
          const { data } = response;
          return data;
        }
      },
    }
  );

  return (
    <>
      <div className="flex min-h-screen">
        <div className="flex flex-col justify-between flex-1 px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="flex flex-col items-center justify-center gap-4 sm:gap-0 sm:justify-between sm:flex-row">
            <LogoWithLanguage />
          </div>
          <div className="flex flex-col justify-center flex-1 w-full max-w-sm lg:w-96">
            <div>
              <h2 className="mt-6 text-3xl font-bold text-gray-700">
                {!!sessionInfo?.id ? t("welcome") : t("notStarted")}
              </h2>

              {!!sessionInfo?.id ? (
                <button
                  onClick={() => navigate(`/learner/room/${learner_token}`)}
                  className="mt-6 w-full  max-w-[131px] py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                >
                  {t(`enterSession`)}
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
          {/* <div /> */}
        </div>
        <div className="relative flex-1 hidden w-0 lg:block">
          <img
            className="absolute inset-0 object-cover w-full h-full"
            src={LoginHero}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
export default SessionWaitingPage;
